import Header from "./Header";
import Section from "./Section";
import React, { Suspense, useState, useEffect, useRef } from "react";
import SectionInsights from "../sectionInsight";
import "./dashboard.css";
import { Element } from "react-scroll";
import { useDispatch, useSelector } from "react-redux";
import {
  Space,
  Row,
  Popover,
  Image,
  Modal,
  Button,
  Checkbox,
  Badge,
  Avatar,
  Tooltip,
} from "antd";
import logoLoc from "../../../assets/Locobuzz_logo.png";
import Datetime from "../../layout/DateTime";
import {
  callNotification,
  deepCopy,
  getChannelNameFromHiddenFilter,
  getGlobalFilterAndFilterCountObject,
  getPaneIndex,
  getPrivateConversationFilters,
  mergeArrays,
  removeHiddenFromSaved,
  removePrivateConversationFilters,
} from "../../../redux/constants";
import Widget from "../sectionInsight/Widget";
import Default_Brand from "../../../assets/brandLogos/Default_Brand.svg";
import filterSmall from "../../../assets/filterIcon.svg";
import filterSmallWhite from "../../../assets/WhiteIcons/filterIconWhite.svg";
import uuid from "react-uuid";
import DeepDive from "../../layout/DeepDive";
import AccountNoData from "../../../assets/no_data-config.svg";

import WidgetHeader from "../sectionInsight/Widget/Header";
import {
  setCallPpt,
  setPPTModalOpen,
  setAIInsightStatus,
  setDeeperAIInsightStatus,
} from "../../../redux/actions/PPT";
import ErrorBoundary from "antd/lib/alert/ErrorBoundary";
import moment from "moment";
import TicketOverview from "../TicketOverview/index";
import ProfileSelection from "../../layout/WelcomePage/Template/ProfileSelection";
import TicketTATSimpleViewSection from "../TicketTATSimpleView/TicketTATSimpleViewSection";
import AgentActivitySectionInsights from "../AgentActivityDashboard/AgentActivitySectionInsights";
import WidgetMakerChart from "../../WidgetMaker/Chart";
import AIInsightsModal from "../AIInsightsModal/index";
import isEqual from "react-fast-compare";
import {
  setClearGraphData,
  setGlobalProfileFilterList,
  setIsActiveAdCampaignStatusInPane,
  setPrivateConversation,
  setPublicEngagementConversation,
} from "../../../redux/actions/dashboard/Tab1";
import FilterDrawer from "../../layout/Workspace/drawers/FilterDrawer";
import { setisFilterPanelVisible } from "../../../redux/actions/Filter";
import { setEditPanel } from "../../../redux/actions/dashboard/dashboard";
import informationButton from "../../../assets/information-button.svg";
import EditWidgetMetaData from "../sectionInsight/Widget/EditWidgetMetaData";
import AgentActivityTrends from "../AgentActivityDashboard/AgentActivityTrends";
import NoAiAcessImage from "../../../assets/no_ai_access_image.png";
import NoAccessAI from "../NoAccessAI";
import { useIsOverflow } from "../../shared/Hooks/useIsOverflow";
import { setProfileList } from "../../../redux/actions/WidgetMaker/WidgetAPI";
import CustomDurationCalendar from "../../layout/DateTime/customCalendar";
import DeepDiveDashboard from "../../../features/DeepDiveDashboard";
import BrandsLogicalGroup from "../../layout/WelcomePage/Template/BrandsLogicalGroup";

const Socailchannel = React.lazy(() =>
  import("../../layout2/socialChannels/index")
);
const OrmWidget = React.lazy(() => import("../../layout2/ORMWidget/index"));

const Dashboard = ({ share }) => {
  const [isDeaperinstights, setDeaperinstights] = useState("peak");
  const [searchTerm, setSearchTerm] = useState(null);
  const [filterSearch, setfilterSearch] = useState("");
  const [filterClearTrigger, setfilterClearTrigger] = useState(false);
  const [load, setLoad] = useState(false);
  const dispatch = useDispatch();
  const styles = {
    width: "100%",
    height: "260px",
  };
  const competitorBrands = useSelector(
    (state) => state.WidgetAPI.competitorBrands?.data?.result
  );
  const shareTemplateData = useSelector(
    (state) => state.ApiCall.shareTemplateData
  );
  const userBrandLoader = useSelector((state) => state.ApiCall.userBrandLoader);
  const aiInsightsStatus = useSelector((state) => state.PPT.aiInsightsStatus);
  const shareBrands = useSelector((state) => state.ApiCall.shareBrands);
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);
  const isWidgetEdit = useSelector((state) => state.Filter.isWidgetEdit);
  const panes = useSelector((state) => state.Tab1.panes);
  let index = getPaneIndex(panes, activeKey);
  const All_Share_attributes = useSelector(
    (state) => state.WidgetMaker.All_Share_attributes
  );
  const temporary_words = useSelector(
    (state) => state?.attributes?.temporary_words
  );
  const deepdiveDashboardTemplateData = useSelector(
    (state) => state?.DeepDiveDashboard?.dashboardTemplateData
  );
  const aiInsightsLoader = useSelector((state) => state.PPT.aiInsightsLoader);
  const sectionLoader = useSelector((state) => state.ApiCall.sectionLoader); //display chart loader
  const templateSectionFetchLoader = useSelector(
    (state) => state.ApiCall.templateSectionFetchLoader
  ); //display chart loader
  const templateListLoader = useSelector(
    (state) => state.ApiCall.templateListLoader
  );
  const brands = useSelector(
    (state) => state.ApiCall.brands?.data?.result?.brands
  );
  const loginAccountType = useSelector(
    (state) => state?.ApiCall?.login_account_type
  );
  const graphLoader = useSelector((state) => state.apiCall.loader); //display chart loader
  const profileLoader = useSelector((state) => state.apiCall.profileLoader);
  const multileProfileSelectionInShare = useSelector(
    (state) => state?.ApiCall?.multileProfileSelection
  );
  const multileBrandSelectionInShare = useSelector(
    (state) => state?.ApiCall?.allow_multiple_brand
  );
  const activeSectionKey = useSelector(
    (state) => state.Section.activeSectionKey
  );
  const brandlogicalgroup = useSelector(
    (state) => state.ApiCall.brandlogicalgroup?.data?.result
  );
  const graphConditionConfig = useSelector(
    (state) => state?.apiCall?.graphConditions
  );
  const workspace_privileges = useSelector(
    (state) => state.ApiCall.workspace_privileges
  );
  const call_ppt = useSelector((state) => state.PPT.call_ppt);
  const authParams = useSelector((state) => state.Authentication.authParams);
  const profileList = useSelector((state) => state.WidgetAPI.profileList);
  const globalLoader = useSelector((state) => state.ApiCall.globalLoader);
  const tabDetails = panes?.[index]; //for only widgets without section
  const section = panes?.[index]?.section; //for only widgets without section
  const sections = panes?.[index]?.sections;
  const total_brands_count = share
    ? (shareBrands?.selected_brand_groups &&
      shareBrands?.selected_brand_groups?.length > 1
        ? shareBrands?.selected_brand_groups?.length - 1
        : 0) +
      (shareBrands?.selected_brand_ids
        ? shareBrands?.selected_brand_groups?.length > 0
          ? shareBrands?.selected_brand_ids?.length
          : shareBrands?.selected_brand_ids?.length - 1
        : 0) +
      (shareBrands?.selected_brand_ids
        ? shareBrands?.selected_comp_brand_ids &&
          shareBrands?.selected_comp_brand_ids?.length
        : 0)
    : 0;

  const globalFinalFilter = getGlobalFilterAndFilterCountObject(
    "share_dashboard",
    deepCopy(shareTemplateData),
    graphConditionConfig
  );

  const brandNameContainer = useRef();
  const [isBrandNameAreOverflowed, setIsBrandNameAreOverflowed] =
    useState(false);
  const isBrandNameAreOverflowedHook = useIsOverflow(
    brandNameContainer,
    (isOverflowFromCallback) => {
      if (isOverflowFromCallback) {
        setIsBrandNameAreOverflowed(isOverflowFromCallback);
      }
    },
    "horizontal"
  );
  const [isActiveAdCampaign, setIsActiveAdCampaign] = useState(
    panes?.[index]?.is_active_ad_campaign
      ? panes?.[index]?.is_active_ad_campaign
      : false
  );

  //fix tab switch rendering time dynamic set to 0
  useEffect(() => {
    let timeout = setTimeout(() => {
      setLoad(true);
    }, 0);
    return () => clearTimeout(timeout);
  }, []);

  useEffect(() => {
    let interval;
    let pathName = window.location.pathname?.split("/")?.[1];
    if (
      (graphConditionConfig?.[`realtime_template-global_filters`]?.[
        panes[index]?.template_id
      ] &&
        graphConditionConfig?.[`realtime_template-global_filters`]?.[
          panes[index]?.template_id
        ]?.length === 0) ||
      (graphConditionConfig?.[`realtime_template-global_filters`]?.[
        shareTemplateData?.template_id
      ] &&
        graphConditionConfig?.[`realtime_template-global_filters`]?.[
          shareTemplateData?.template_id
        ]?.length === 0)
    ) {
      interval = setInterval(() => {
        // to clear graph data after every 1 min
        if (shareBrands) {
          let shareObj = {
            shareBrands: shareBrands,

            shareData: shareTemplateData,

            change_type: "global_duration",
          };

          dispatch(setClearGraphData(null, null, "share", shareObj));
        } else if (pathName === "dashboard" || pathName === "pin-dashboard") {
          dispatch(setClearGraphData(index, panes, null));
        }
      }, 60000);

      return () => clearInterval(interval);
    }
  }, [panes]);

  useEffect(() => {
    if (authParams?.ppt == 1 && !call_ppt) {
      dispatch(setCallPpt(true));
      dispatch(setPPTModalOpen(true));
    }
  }, [authParams]);
  const removeFilterPanel = () => {
    dispatch(setisFilterPanelVisible(false));
    setfilterSearch("");
  };
  const addFilterPanel = () => {
    dispatch(setisFilterPanelVisible(true));
    dispatch(setEditPanel(null));
  };
  const handleCheckbox = (e) => {
    window.stop();
    if (e.target.checked) {
      let filters;
      if (
        "selected_pills" in panes?.[index] &&
        panes?.[index]?.selected_pills.length &&
        Object.keys(panes?.[index]?.selected_pills?.[0])?.length
      ) {
        filters = panes?.[index]?.filters;
        let pillsFilter = [
          ...deepCopy(panes?.[index]?.selected_pills?.[0]?.saved_filters),
        ];
        if (filters?.length) {
          let appliedFilters = removeHiddenFromSaved(
            deepCopy(filters),
            deepCopy(panes?.[index]?.comp_hidden_filter)
          );
          if (appliedFilters?.length) {
            filters = mergeArrays(
              deepCopy(pillsFilter),
              deepCopy(appliedFilters)
            );
          } else {
            filters = [...deepCopy(pillsFilter)];
          }
        } else {
          filters = [...deepCopy(pillsFilter)];
        }
      } else {
        filters = removePrivateConversationFilters(
          panes?.[index]?.comp_hidden_filter,
          panes?.[index]?.filters,
          panes?.[index]?.saved_filters
        );
      }
      dispatch(setPrivateConversation(true, panes, index, filters));
      let paneObj = {
        panes: panes,
        activeKey: activeKey,
        brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
        singleBrands: brands,
        authParams: authParams,
        index: index,
        competitorBrands: competitorBrands,
        graphConditionConfig: graphConditionConfig,
      };
      dispatch(setClearGraphData(paneObj?.index, paneObj?.panes, paneObj));
      callNotification(
        "Filters updated by including Private conversations",
        "info"
      );
    } else if (!e.target.checked) {
      let filters;
      if (panes?.[index]?.selected_pills?.[0]?.saved_filters?.length) {
        filters = mergeArrays(
          deepCopy([...panes?.[index]?.comp_hidden_filter]),
          deepCopy([...panes?.[index]?.selected_pills?.[0]?.saved_filters])
        );
        if (panes?.[index]?.filters?.length) {
          filters = mergeArrays(
            deepCopy(filters),
            deepCopy(panes?.[index]?.filters)
          );
        }
        panes[index].filters = filters;
      } else {
        filters = getPrivateConversationFilters(
          panes?.[index]?.comp_hidden_filter,
          panes?.[index]?.filters
        );
      }
      dispatch(setPrivateConversation(false, panes, index, filters));
      let paneObj = {
        panes: panes,
        activeKey: activeKey,
        brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
        singleBrands: brands,
        authParams: authParams,
        index: index,
        competitorBrands: competitorBrands,
        graphConditionConfig: graphConditionConfig,
      };
      dispatch(setClearGraphData(paneObj?.index, paneObj?.panes, paneObj));
      callNotification(
        "Filters updated by excluding Private conversations",
        "info"
      );
    }
  };
  const handlePublicEngagementCheckbox = (e) => {
    window.stop();
    if (e.target.checked) {
      dispatch(setPublicEngagementConversation(true, panes, index));
      let paneObj = {
        panes: panes,
        activeKey: activeKey,
        brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
        singleBrands: brands,
        authParams: authParams,
        index: index,
        competitorBrands: competitorBrands,
        graphConditionConfig: graphConditionConfig,
      };
      dispatch(
        setClearGraphData(paneObj?.index, paneObj?.panes, "global_changes")
      );
      callNotification("Widgets updated", "info");
    } else if (!e.target.checked) {
      dispatch(setPublicEngagementConversation(false, panes, index));
      let paneObj = {
        panes: panes,
        activeKey: activeKey,
        brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
        singleBrands: brands,
        authParams: authParams,
        index: index,
        competitorBrands: competitorBrands,
        graphConditionConfig: graphConditionConfig,
      };
      dispatch(
        setClearGraphData(paneObj?.index, paneObj?.panes, "global_changes")
      );
      callNotification("Widgets updated", "info");
    }
  };
  const handleAdCampaignCheckbox = (e) => {
    window.stop();
    let isChecked = e?.target?.checked;
    setIsActiveAdCampaign(isChecked);
    dispatch(setIsActiveAdCampaignStatusInPane(isChecked, index));

    let filterForAdCampaign = isChecked
      ? [
          {
            attribute: "campaign_status",
            type: "varchar",
            columns: [
              {
                name: "Active",
                type: "include",
                display_name: "Active",
              },
              {
                name: "Running",
                type: "include",
                display_name: "Running",
              },
            ],
          },
        ]
      : [];

    let paneObject = {
      panes: panes,
      activeKey: activeKey,
      brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
      authParams: authParams,
      index: index,
      singleBrands: brands,
      competitorBrands: competitorBrands,
      graphConditionConfig: graphConditionConfig,
      is_modified_date:
        panes?.[index]?.template_id === "000-000-002" ||
        panes?.[index]?.template_id === "000-000-004"
          ? panes?.[index]?.is_modified_date
            ? panes?.[index]?.is_modified_date
            : false
          : null,
      temporary_words: temporary_words,
    };

    let profilePayload = {
      hidden_filter: panes?.[index]?.hidden_filter,
      quick_filter: panes?.[index]?.quick_filter,
      saved_filters: panes?.[index]?.saved_filters,
      filterForAdCampaign: filterForAdCampaign,
      isBrandModified: panes?.[index]?.brands ? true : false,
      brands: panes?.[index]?.brands
        ? panes[index]?.brands?.columns
          ? panes[index]?.brands?.columns
          : panes[index]?.brands
        : paneObject?.brands,
      start_date: panes?.[index]?.duration
        ? panes?.[index]?.duration?.from
        : null,
      end_date: panes?.[index]?.duration ? panes[index]?.duration?.to : null,
      description: panes?.[index]?.template_description,
      is_brand_locked: panes?.[index]?.is_brand_locked,
      is_date_locked: panes?.[index]?.is_date_locked,
      template_name: panes?.[index]?.template_name,
      template_id: panes?.[index]?.template_id,
      predefined: panes?.[index]?.predefined,
      template_type: panes?.[index]?.template_type,
      competition_aggregation: panes?.[index]?.competition_aggregation,
    };
    let section_id = panes[index]?.sections
      ? panes[index]?.sections[0].section_id
      : panes[index]?.section && panes[index]?.section[0].section_id;
    dispatch(
      setProfileList(
        authParams,
        profilePayload,
        paneObject,
        "active_ads_campaign_status",
        section_id
      )
    );
    // clear profile list
    // Set null profile_filter_list in panes
    dispatch(setGlobalProfileFilterList(null, panes, index));
    // callNotification(
    //   `AD Campaigns updated by ${
    //     isChecked ? "including" : "excluding"
    //   } Active Campaigns Only`,
    //   "info"
    // );
  };

  if (!load)
    return (
      <div
        className="d-flex align-items-center"
        style={{
          justifyContent: "space-evenly",
          height: "calc(100vh - 6rem)",
        }}
      >
        <div className="lds-ring">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    );
  else
    return (
      <>
        {templateSectionFetchLoader ||
        userBrandLoader ||
        templateListLoader ||
        globalLoader ||
        (authParams?.template_id && sectionLoader?.index == 0) ? (
          <div
            className="loader text-center w-100"
            style={{ height: "calc(100vh - 3.8rem)" }}
          >
            <div className="lds-ring">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        ) : share &&
          !shareTemplateData?.isDeepDive &&
          !shareTemplateData?.isDeepDiveDashboard ? (
          <>
            <div className="section-sticky bg__white">
              <div className="p-15 share_header border-bottom border-color flex-wrap d-flex justify-content-between">
                <Space>
                  {" "}
                  <div
                    className="d-flex align-items-center"
                    style={{ marginTop: "0.5rem" }}
                  >
                    <img src={logoLoc} alt="locobuzz" className="mr-15" />
                    <div className="floating-label-group header-brands mb-1 analytics_brand">
                      {graphConditionConfig?.account_detail_templates?.includes(
                        shareTemplateData?.template_id
                      ) ? (
                        <Popover
                          color="#3B5175"
                          className="custom_scroll"
                          placement="bottom"
                          content={() => (
                            <div
                              className="custom_scroll p-2"
                              style={{
                                maxHeight: "20rem",
                                overflow: "auto",
                                maxWidth: "20rem",
                              }}
                            >
                              {shareBrands?.selected_account_list?.length && (
                                <>
                                  <span
                                    style={{ color: "grey" }}
                                    className="pt-2 pb-2"
                                  >
                                    Account
                                  </span>
                                  {shareBrands?.selected_account_list ? (
                                    shareBrands?.selected_account_list?.map(
                                      (el) => (
                                        <div
                                          style={{
                                            color: "white",
                                            maxHeight: "20rem",
                                            overflow: "auto",
                                          }}
                                          className="mb-1"
                                        >
                                          {el?.display_name}
                                        </div>
                                      )
                                    )
                                  ) : (
                                    <div
                                      style={{
                                        color: "white",
                                        maxHeight: "20rem",
                                        overflow: "auto",
                                      }}
                                      className="mb-1"
                                    >
                                      No Account
                                    </div>
                                  )}
                                </>
                              )}
                            </div>
                          )}
                          overlayClassName={
                            authParams?.theme_type === "1"
                              ? "darkTheme"
                              : "lightTheme"
                          }
                        >
                          <div
                            className="border-color border border-radius-4 cursor-pointer d-flex align-items-center"
                            style={{
                              padding: "0.8rem 1.2rem",
                              maxWidth: "19rem",
                            }}
                          >
                            <span className="ml-2 text_regular">
                              {`${
                                shareBrands?.selected_account_list
                                  ? shareBrands?.selected_account_list[0]
                                      .display_name
                                  : "no account"
                              } 
														`}
                            </span>
                            <label
                              className="portlet-label floating-label mr-15"
                              style={{
                                backgroundColor: "rgb(255, 255, 255)",
                                fontSize: "1.2rem",
                                top: "-0.8rem",
                              }}
                            >
                              Account
                            </label>
                          </div>
                        </Popover>
                      ) : multileBrandSelectionInShare ? (
                        <BrandsLogicalGroup
                          dropdown={false}
                          type="share_dashboard_global"
                        />
                      ) : (
                        <Popover
                          color="#3B5175"
                          className="custom_scroll"
                          placement="bottom"
                          content={() => (
                            <div
                              className="custom_scroll p-2"
                              style={{
                                maxHeight: "20rem",
                                overflow: "auto",
                                maxWidth: "20rem",
                              }}
                            >
                              {shareBrands?.selected_brand_groups?.length >
                                0 && (
                                <>
                                  <span
                                    style={{ color: "grey" }}
                                    className="pt-2 pb-2"
                                  >
                                    Logical Group
                                  </span>
                                  {shareBrands?.selected_brand_groups &&
                                  Array.isArray(
                                    shareBrands?.selected_brand_groups
                                  ) ? (
                                    shareBrands?.selected_brand_groups?.map(
                                      (el) => (
                                        <Tooltip
                                          title={el?.brand_group_name}
                                          placement="right"
                                        >
                                          <div
                                            style={{
                                              color: "white",
                                              maxHeight: "20rem",
                                              // overflow: "auto",
                                            }}
                                            className="mb-1 text-ellipsis"
                                          >
                                            {el?.brand_group_name}
                                          </div>
                                        </Tooltip>
                                      )
                                    )
                                  ) : (
                                    <div
                                      style={{
                                        color: "white",
                                        maxHeight: "20rem",
                                        overflow: "auto",
                                      }}
                                      className="mb-1"
                                    >
                                      No Brand groups
                                    </div>
                                  )}
                                </>
                              )}

                              {shareBrands?.selected_brand_ids?.length > 0 && (
                                <>
                                  <span
                                    style={{ color: "grey" }}
                                    className="pt-2 pb-2"
                                  >
                                    Brands
                                  </span>
                                  {shareBrands?.selected_brand_ids ? (
                                    shareBrands?.selected_brand_ids?.map(
                                      (el) => (
                                        <Tooltip
                                          title={el?.brand_friendly_name}
                                          placement="right"
                                        >
                                          <div
                                            style={{
                                              color: "white",
                                              maxHeight: "20rem",
                                              // overflow: "auto",
                                            }}
                                            className="mb-1 text-ellipsis"
                                          >
                                            {el?.brand_friendly_name}
                                          </div>
                                        </Tooltip>
                                      )
                                    )
                                  ) : (
                                    <div
                                      style={{
                                        color: "white",
                                        maxHeight: "20rem",
                                        overflow: "auto",
                                      }}
                                      className="mb-1"
                                    >
                                      No Brand
                                    </div>
                                  )}
                                </>
                              )}
                              {shareBrands?.selected_comp_brand_ids?.length >
                                0 && (
                                <>
                                  <span
                                    style={{ color: "grey" }}
                                    className="pt-2 pb-2"
                                  >
                                    Competitor Brands
                                  </span>
                                  {shareBrands?.selected_comp_brand_ids
                                    ?.length > 0 ? (
                                    shareBrands?.selected_comp_brand_ids?.map(
                                      (el) => (
                                        <Tooltip
                                          title={el?.brand_friendly_name}
                                          placement="right"
                                        >
                                          <div
                                            style={{
                                              color: "white",
                                              maxHeight: "20rem",
                                              // overflow: "auto",
                                            }}
                                            className="mb-1 text-ellipsis"
                                          >
                                            {el?.brand_friendly_name}
                                          </div>
                                        </Tooltip>
                                      )
                                    )
                                  ) : (
                                    <div
                                      style={{
                                        color: "white",
                                        maxHeight: "20rem",
                                        overflow: "auto",
                                      }}
                                      className="mb-1"
                                    >
                                      No Brand
                                    </div>
                                  )}
                                </>
                              )}
                            </div>
                          )}
                          overlayClassName={
                            authParams?.theme_type === "1"
                              ? "darkTheme"
                              : "lightTheme"
                          }
                        >
                          <div
                            className="border-color border border-radius-4 cursor-pointer d-flex align-items-center"
                            style={{
                              padding: "0.8rem 1.2rem",
                              maxWidth: "19rem",
                            }}
                          >
                            <Image
                              src={
                                shareBrands?.selected_brand_groups?.[0]
                                  ?.brand_logo
                                  ? shareBrands?.selected_brand_groups?.[0]
                                      ?.brand_logo
                                  : shareBrands?.selected_brand_ids?.[0]
                                      ?.brand_logo
                                  ? shareBrands?.selected_brand_ids?.[0]
                                      ?.brand_logo
                                  : Default_Brand
                              }
                              alt="Brand"
                              style={{
                                width: "1.6rem",
                                height: "1.6rem",
                                minWidth: "1.6rem",
                                borderRadius: "50%",
                              }}
                              fallback={Default_Brand}
                              preview={false}
                              //className="border border-color box-shadow"
                            />
                            <span
                              className="ml-2 text_regular d-flex"
                              style={{ minWidth: "calc(100% - 3.2rem)" }}
                              ref={brandNameContainer}
                            >
                              <span
                                className={`text-nowrap  ${
                                  isBrandNameAreOverflowed
                                    ? "text-ellipsis"
                                    : ""
                                }`}
                                style={
                                  isBrandNameAreOverflowed
                                    ? { maxWidth: "calc(100% - 2rem)" }
                                    : {}
                                }
                              >{`${
                                shareBrands?.selected_brand_groups?.[0]
                                  ?.brand_group_name
                                  ? shareBrands?.selected_brand_groups?.[0]?.brand_group_name?.trim()
                                  : shareBrands?.selected_brand_ids?.[0]?.brand_friendly_name?.trim()
                                  ? shareBrands?.selected_brand_ids?.[0]?.brand_friendly_name?.trim()
                                  : "No brands"
                              }`}</span>
                              {` ${
                                total_brands_count > 0
                                  ? "+" + total_brands_count
                                  : ""
                              }
														`}
                            </span>
                            <label
                              className="portlet-label floating-label mr-15"
                              style={{
                                backgroundColor: "rgb(255, 255, 255)",
                                fontSize: "1.2rem",
                                top: "-0.8rem",
                              }}
                            >
                              Brand
                            </label>
                          </div>
                        </Popover>
                      )}
                    </div>
                  </div>
                  {shareTemplateData?.quick_filter && (
                    <ErrorBoundary>
                      <div
                        style={{
                          // pointerEvents: "none",
                          marginTop: "0.5rem",
                        }}
                        className={`floating-label-group ProfileSelection header-brands ml-15 analytics_brand ${
                          multileProfileSelectionInShare?.searchQuickFilterLoader
                            ? "disable"
                            : ""
                        }`}
                      >
                        <ProfileSelection
                          AccountType={
                            shareTemplateData?.quick_filter?.attribute ===
                            "SettingID"
                              ? "AccountID"
                              : shareTemplateData?.quick_filter?.attribute
                          }
                          type="share-dashboard"
                        />
                        <label
                          className="portlet-label floating-label mr-15"
                          style={{
                            backgroundColor: "#fff",
                            top: "-0.8rem",
                            fontSize: "1.2rem",
                          }}
                        >
                          {shareTemplateData?.quick_filter?.attribute ===
                          "SettingID"
                            ? "Profiles"
                            : shareTemplateData?.quick_filter?.attribute ===
                              "ObjectID"
                            ? "Form"
                            : shareTemplateData?.quick_filter?.attribute ===
                              "LocationID"
                            ? "Location"
                            : shareTemplateData?.quick_filter?.attribute?.toLowerCase() ===
                              "fbgroupid"
                            ? "Facebook Group"
                            : shareTemplateData?.quick_filter?.attribute ===
                              "Ticket_Tagging"
                            ? "Labels"
                            : shareTemplateData?.quick_filter?.attribute ===
                              "CategoryID"
                            ? "Category"
                            : shareTemplateData?.quick_filter?.attribute ===
                              "Ads_Campaign"
                            ? "AD Campaign"
                            : shareTemplateData?.quick_filter?.attribute ===
                              "ProfileID"
                            ? "Location Profiles"
                            : shareTemplateData?.quick_filter?.attribute ===
                                "CampaignID" && "Campaigns"}
                        </label>
                      </div>
                    </ErrorBoundary>
                  )}
                  {shareTemplateData?.quick_filter?.attribute ===
                    "Ads_Campaign" &&
                  Array.isArray(shareTemplateData?.adsset_list) &&
                  shareTemplateData?.adsset_list?.length ? (
                    <ErrorBoundary>
                      <div
                        style={{
                          // pointerEvents: "none",
                          marginTop: "5px",
                        }}
                        className={`floating-label-group ProfileSelection header-brands ml-15 analytics_brand ${
                          multileProfileSelectionInShare?.searchQuickFilterLoader
                            ? "disable"
                            : ""
                        }`}
                      >
                        <ProfileSelection
                          AccountType={
                            shareTemplateData?.quick_filter?.attribute ===
                            "SettingID"
                              ? "AccountID"
                              : shareTemplateData?.quick_filter?.attribute
                          }
                          IsAdsSetType={true}
                          type="share-dashboard"
                        />
                        <label
                          className="portlet-label floating-label mr-15"
                          style={{
                            backgroundColor: "#fff",
                            top: "-8px",
                            fontSize: "12px",
                          }}
                        >
                          {"AD Sets"}
                        </label>
                      </div>
                    </ErrorBoundary>
                  ) : (
                    ""
                  )}
                  {shareTemplateData?.quick_filter?.attribute ===
                    "Ads_Campaign" &&
                  Array.isArray(shareTemplateData?.ads_list) &&
                  shareTemplateData?.ads_list?.length ? (
                    <ErrorBoundary>
                      <div
                        style={{
                          // pointerEvents: "none",
                          marginTop: "5px",
                        }}
                        className={`floating-label-group ProfileSelection header-brands ml-15 analytics_brand ${
                          multileProfileSelectionInShare?.searchQuickFilterLoader
                            ? "disable"
                            : ""
                        }`}
                      >
                        <ProfileSelection
                          AccountType={
                            shareTemplateData?.quick_filter?.attribute ===
                            "SettingID"
                              ? "AccountID"
                              : shareTemplateData?.quick_filter?.attribute
                          }
                          IsAdsType={true}
                          type="share-dashboard"
                        />
                        <label
                          className="portlet-label floating-label mr-15"
                          style={{
                            backgroundColor: "#fff",
                            top: "-8px",
                            fontSize: "12px",
                          }}
                        >
                          {"ADs"}
                        </label>
                      </div>
                    </ErrorBoundary>
                  ) : (
                    ""
                  )}
                </Space>

                {/* In Campaign case duration is now made changable (CS team req.) */}
                {/* Disable logic commented, now in campaign we can change duration */}
                <div
                  className={`d-flex ${
                    shareTemplateData?.dashboard_called_api_list?.length > 0
                      ? "disable"
                      : ""
                  }`}
                  // className="d-flex"
                  style={{
                    marginTop: "0.5rem",
                    // opacity:
                    //   shareTemplateData?.quick_filter?.attribute ===
                    //   "CampaignID"
                    //     ? "0.5"
                    //     : "1",
                    // pointerEvents:
                    //   shareTemplateData?.quick_filter?.attribute ===
                    //   "CampaignID"
                    //     ? "none"
                    //     : "auto",
                  }}
                >
                  {graphConditionConfig?.template_calender_action_controls?.includes(
                    shareTemplateData?.template_id
                  ) ? (
                    <CustomDurationCalendar type="share_modal" />
                  ) : (
                    ""
                  )}
                  {!graphConditionConfig?.template_calender_action_controls?.includes(
                    shareTemplateData?.template_id
                  ) &&
                    !graphConditionConfig?.[
                      `realtime_template-global_filters`
                    ]?.[shareTemplateData?.template_id] && (
                      <div
                        className={`${
                          shareTemplateData?.is_date_locked ? "disable" : ""
                        }`}
                      >
                        <ErrorBoundary>
                          <Datetime type="share_modal" />
                        </ErrorBoundary>
                      </div>
                    )}

                  {!graphConditionConfig?.template_calender_action_controls?.includes(
                    shareTemplateData?.template_id
                  ) &&
                  !["000-000-004", "000-000-001"]?.includes(
                    shareTemplateData?.template_id
                  ) &&
                  (!graphConditionConfig?.[
                    `realtime_template-global_filters`
                  ]?.[shareTemplateData?.template_id] ||
                    (graphConditionConfig?.[
                      `realtime_template-global_filters`
                    ]?.[shareTemplateData?.template_id] &&
                      graphConditionConfig?.[
                        `realtime_template-global_filters`
                      ]?.[shareTemplateData?.template_id]?.length)) &&
                  shareTemplateData?.["show_filters"] ? (
                    <Tooltip
                      overlayStyle={{
                        width:
                          shareTemplateData &&
                          shareTemplateData?.filters?.length > 0 &&
                          shareTemplateData?.filters?.findIndex((el) => {
                            return !graphConditionConfig?.[
                              `quick-filter-keys`
                            ]?.includes(el?.attribute);
                          }) !== -1 &&
                          "20rem",
                      }}
                      color="#3B5175"
                      title={
                        globalFinalFilter?.filters?.length > 0 ? (
                          <div
                            className="custom_scroll"
                            style={{
                              maxWidth: "27rem",
                              maxHeight: "23rem",
                              overflow: "auto",
                              scrollBehavior: "smooth",
                            }}
                          >
                            <div className="mb-1">
                              {globalFinalFilter?.filters?.map((el) => {
                                let data =
                                  panes?.[index]?.filterPanelData?.result
                                    ?.schema[el?.attribute]?.values;

                                return !(
                                  shareTemplateData === "000-000-002" ||
                                  shareTemplateData === "000-000-003"
                                ) ? (
                                  globalFinalFilter?.filters?.length ? (
                                    <div className="mb-2">
                                      <p
                                        className="mb-0"
                                        style={{
                                          color:
                                            el?.type === "include"
                                              ? "#5ed66d"
                                              : el?.type === "exclude" &&
                                                "#fb7665",
                                        }}
                                      >
                                        <strong>
                                          {All_Share_attributes
                                            ? All_Share_attributes?.[
                                                el?.attribute
                                              ]
                                              ? All_Share_attributes?.[
                                                  el?.attribute
                                                ]
                                              : el?.attribute?.toLowerCase() ===
                                                "categoryid"
                                              ? "Category"
                                              : el?.attribute?.toLowerCase() ===
                                                "subcategoryid_aug"
                                              ? "Sub Category"
                                              : el?.attribute?.toLowerCase() ===
                                                "subsubcategoryid"
                                              ? "Sub Sub Category"
                                              : el?.attribute?.endsWith("ID")
                                              ? el?.attribute?.replace("ID", "")
                                              : el?.attribute?.replace(
                                                  "Type",
                                                  ""
                                                )
                                            : el?.attribute?.replace(
                                                "Type",
                                                ""
                                              )}
                                        </strong>
                                      </p>
                                      {el?.type === "int" &&
                                        !Array.isArray(el?.columns) && (
                                          <span className="font-weight-light text-white">
                                            {el?.columns?.from +
                                              " - " +
                                              el?.columns?.to}
                                          </span>
                                        )}
                                      {Array.isArray(el?.columns) &&
                                        el?.columns?.map((e, index) => {
                                          return (
                                            <span
                                              className="font-weight-light"
                                              style={{
                                                color:
                                                  e?.type === "include"
                                                    ? "#5ed66d"
                                                    : e?.type === "exclude"
                                                    ? "#fb7665"
                                                    : "#fff",
                                              }}
                                            >
                                              {/* {(index ? ", " : "") +
                                                (e?.display_name
                                                  ? e?.display_name
                                                  : e?.name)} */}
                                              {[
                                                "FeedBackEnabled",
                                                "ShowDeletedFromSocial",
                                                "AutoClosureEnabled",
                                                "IsWorkingHour",
                                              ]?.includes(el?.attribute)
                                                ? e?.name === null
                                                  ? "Any"
                                                  : e?.name === 0
                                                  ? "No"
                                                  : e?.name === 1 && "Yes"
                                                : (index ? ", " : "") +
                                                  (e?.display_name
                                                    ? e?.display_name
                                                    : e?.name)}
                                            </span>
                                          );
                                        })}
                                    </div>
                                  ) : (
                                    "Filter"
                                  )
                                ) : (
                                  <div className="mb-2">
                                    <p className="mb-0 text-white">
                                      <strong>
                                        {shareTemplateData?.template_id ===
                                          "000-000-003" &&
                                        el?.attribute === "IsWorkingHour"
                                          ? "Is Working Hour"
                                          : All_Share_attributes &&
                                            All_Share_attributes[el?.attribute]
                                          ? All_Share_attributes[el?.attribute]
                                          : panes[index]?.filterPanelData
                                              ?.result?.schema
                                          ? panes[index]?.filterPanelData
                                              ?.result?.schema?.[el?.attribute]
                                              ?.title
                                          : el?.attribute?.toLowerCase() ===
                                            "categoryid"
                                          ? "Category"
                                          : el?.attribute?.toLowerCase() ===
                                            "subcategoryid_aug"
                                          ? "Sub Category"
                                          : el?.attribute?.toLowerCase() ===
                                            "subsubcategoryid"
                                          ? "Sub Sub Category"
                                          : el?.attribute?.replace("Type", "")}
                                      </strong>
                                    </p>
                                    {Array.isArray(el?.columns) &&
                                      el?.columns?.map((e, index) => {
                                        return (
                                          <span
                                            className="font-weight-light"
                                            style={{
                                              color:
                                                e?.type === "include"
                                                  ? "#5ed66d"
                                                  : e?.type === "exclude"
                                                  ? "#fb7665"
                                                  : "#fff",
                                            }}
                                          >
                                            {[
                                              "FeedBackEnabled",
                                              "ShowDeletedFromSocial",
                                              "AutoClosureEnabled",
                                              "IsWorkingHour",
                                            ]?.includes(el?.attribute)
                                              ? e?.name === null
                                                ? "Any"
                                                : e?.name === 0
                                                ? "No"
                                                : e?.name === 1 && "Yes"
                                              : (index ? ", " : "") +
                                                data?.filter(
                                                  (g) => e?.name === g?.id
                                                )[0]?.name}
                                          </span>
                                        );
                                      })}
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        ) : (
                          "Filter"
                        )
                      }
                      placement="leftTop"
                    >
                      <Badge
                        style={{ backgroundColor: "#185edf", fontSize: "1rem" }}
                        size="small"
                        count={
                          globalFinalFilter?.filters
                            ? globalFinalFilter?.filters?.length
                            : 0
                        }
                      >
                        <Button
                          className="header-btn ml-2 p-0 shadow-none border-color"
                          onClick={() => addFilterPanel()}
                        >
                          <Avatar
                            shape="square"
                            size="small"
                            src={
                              authParams?.theme_type === "1"
                                ? filterSmallWhite
                                : filterSmall
                            }
                            alt="Header Filter"
                          />
                        </Button>
                      </Badge>
                    </Tooltip>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              {shareTemplateData && (
                <ErrorBoundary>
                  <Section
                    shareTemplateData={shareTemplateData}
                    sections={shareTemplateData?.sections}
                  />
                </ErrorBoundary>
              )}
            </div>
            {shareTemplateData?.sections?.length > 0 && (
              <div className="p-15 pb-0 bg__gray full section_insight">
                {shareTemplateData?.sections?.map((el, i) => {
                  return (
                    el?.widgets && (
                      <Element name={el.section_id} key={i} id={el?.section_id}>
                        <SectionInsights
                          key={el?.section_id}
                          title={el.section_name}
                          description={el.section_description}
                          widgets={el?.widgets}
                          section_index={i}
                          section_id={el?.section_id}
                          sections={shareTemplateData?.sections}
                          currentSection={el}
                          comprtitorBrandFilter={el?.comp_brand_type}
                        />
                      </Element>
                    )
                  );
                })}
              </div>
            )}

            {/* new code for widget level */}
            <div className="p-15 pb-0 bg__gray full">
              {shareTemplateData?.section && (
                <div style={{ height: "100%" }}>
                  <Row gutter={20} className="mb-3 ml-0">
                    {shareTemplateData?.section?.[0]?.widgets?.map((el, i) => {
                      return (
                        <Widget
                          key={el?.widget_id + i}
                          data={el}
                          onlyWidgets={true}
                          widget_index={i}
                          widget_graph_type={el?.graph_type}
                          section_id={shareTemplateData?.section[0]?.section_id}
                          sections={shareTemplateData?.section}
                          widget_id={el?.widget_id}
                        />
                      );
                    })}
                  </Row>
                </div>
              )}
            </div>
          </>
        ) : !share && panes?.[index]?.is_widget_maker_open_obj?.open_flag ? (
          <EditWidgetMetaData
            editWidgetMetaDataModal={panes?.[index]?.is_widget_maker_open}
            // setEditWidgetMetaDataModal={setEditWidgetMetaDataModal}
          />
        ) : (!share && panes && panes?.[index]?.isDeepDiveDashboard) ||
          (share &&
            shareTemplateData &&
            shareTemplateData?.isDeepDiveDashboard) ? (
          <ErrorBoundary>
            <>
              {deepdiveDashboardTemplateData?.isDeepDive ? (
                <DeepDive />
              ) : (
                <DeepDiveDashboard />
              )}
            </>
          </ErrorBoundary>
        ) : (panes && panes[index].isDeepDive) ||
          (shareTemplateData && shareTemplateData?.isDeepDive) ? (
          <ErrorBoundary>
            <DeepDive />
          </ErrorBoundary>
        ) : (
          <div className="h-100">
            <div className="dashboard-title pt-2 pb-2 bg__white d-flex justify-content-between align-items-center">
              <div>
                <div className="text_heading-Slab font-size16 font-weight500 ml-3 mr-3">
                  {tabDetails?.template_name}
                </div>
                {tabDetails?.template_description &&
                String(tabDetails?.template_description)?.trim()?.length > 0 ? (
                  <div
                    className="text_regular-gray ml-3 mr-3 text__ellipsis-line2"
                    style={{ minHeight: "2.2rem" }}
                  >
                    {tabDetails?.template_description}
                  </div>
                ) : (
                  ""
                )}
              </div>
              {/* {panes[index]?.quick_filter === "Ads_Campaign" ? (
                <div
                  className={`text_heading-Slab font-size16 mr-3 ${
                    panes?.[index]?.dashboard_called_api_list?.length > 0
                      ? "disable"
                      : ""
                  }`}
                  //  className="text_heading-Slab font-size16 mr-3"
                >
                  <Checkbox
                    onChange={(e) => handleAdCampaignCheckbox(e)}
                    checked={isActiveAdCampaign}
                  >
                    {isActiveAdCampaign
                      ? "Showing Active Campaign Only"
                      : "Show Active Campaign Only"}
                    <Tooltip
                      overlayInnerStyle={{
                        width: "450px",
                        borderRadius: "7px",
                        marginLeft: "-350px",
                        marginRight: "30px",
                      }}
                      // placement="bottomLeft"
                      title={
                        <span>
                          Check this to
                          {isActiveAdCampaign ? " exclude " : " include "}
                          Private conversations such as DMs, dark posts and
                          channels like email and Linkedin.
                          <br />
                          For Benchmarking against the competition, use this
                          with an exclusion.
                          <br />
                          For comparing your own brands, use this with
                          inclusion.
                        </span>
                      }
                    >
                      <img
                        src={informationButton}
                        alt="Info"
                        className="cursor-pointer ml-2"
                        style={{ maxWidth: "16px" }}
                      />
                    </Tooltip>
                  </Checkbox>
                </div>
              ) : (
                ""
              )} */}
              {panes[index]?.template_type === "competition" ? (
                <div
                  className={`text_heading-Slab font-size16 mr-3 ${
                    panes?.[index]?.dashboard_called_api_list?.length > 0
                      ? "disable"
                      : ""
                  }`}
                  //  className="text_heading-Slab font-size16 mr-3"
                >
                  {!(workspace_privileges?.environment === 2) ? (
                    <Checkbox
                      onChange={(e) => handlePublicEngagementCheckbox(e)}
                      checked={panes?.[index]?.public_engagement_only}
                      value={true}
                    >
                      Public Engagement
                      <Tooltip
                        overlayInnerStyle={{
                          borderRadius: "0.7rem",
                          marginLeft: "-35rem",
                        }}
                        // placement="bottomLeft"
                        title={
                          <span>
                            {panes?.[index]?.public_engagement_only
                              ? "Uncheck to include other owned metrics in Engagement "
                              : "Check to exclude owned metrics in Engagement  "}
                          </span>
                        }
                      >
                        <img
                          src={informationButton}
                          alt="Info"
                          className="cursor-pointer ml-2"
                          style={{ maxWidth: "1.6rem" }}
                        />
                      </Tooltip>
                    </Checkbox>
                  ) : (
                    ""
                  )}

                  <Checkbox
                    onChange={(e) => handleCheckbox(e)}
                    checked={panes?.[index]?.private_conversation}
                    value={true}
                  >
                    {panes?.[index]?.private_conversation
                      ? "Includes Private Conversations"
                      : "Include Private Conversations"}
                    <Tooltip
                      overlayInnerStyle={{
                        width: "45rem",
                        borderRadius: "0.7rem",
                        marginLeft: "-35rem",
                        marginRight: "3rem",
                      }}
                      // placement="bottomLeft"
                      title={
                        <>
                          <div
                            style={{
                              fontWeight: "bold",
                              marginBottom: "0.5rem",
                            }}
                          >
                            Include Private Conversations
                          </div>
                          <ul
                            style={{
                              paddingLeft: "2.2rem",
                              marginBottom: "0.5rem",
                            }}
                          >
                            <li>
                              Surface DMs, dark posts, Email threads and
                              LinkedIn messages
                            </li>
                            <li>Exclude when benchmarking competitors</li>
                            <li>Include when comparing your own brands</li>
                          </ul>
                          {/* <span>
                            Check this to
                            {panes?.[index]?.private_conversation
                              ? " exclude "
                              : " include "}
                            Private conversations such as DMs, dark posts and
                            channels like email and Linkedin.
                            <br />
                            For Benchmarking against the competition, use this
                            with an exclusion.
                            <br />
                            For comparing your own brands, use this with
                            inclusion.
                          </span> */}
                        </>
                      }
                    >
                      <img
                        src={informationButton}
                        alt="Info"
                        className="cursor-pointer ml-2"
                        style={{ maxWidth: "1.6rem" }}
                      />
                    </Tooltip>
                  </Checkbox>
                </div>
              ) : (
                ""
              )}
            </div>
            <div
              className={`section-sticky bg__white ${
                sections ? "" : "box-shadow_bottom"
              }`}
              style={{
                top:
                  authParams?.template_id && authParams?.v3 ? "3.8rem" : "4rem",
              }}
            >
              <ErrorBoundary>
                <Header />
              </ErrorBoundary>

              {sections && (
                <ErrorBoundary>
                  <Section
                    sections={sections}
                    container={"SectionContainerMain"}
                    isViewDashboard={true}
                  />
                </ErrorBoundary>
              )}
            </div>
            {panes[index]?.predefined &&
            panes[index]?.template_type === "ticket" ? (
              <div className="p-15 pb-0 bg__gray custom_scroll1">
                {panes[index]?.template_id === "000-000-001" &&
                panes[index]?.section ? (
                  <Suspense
                    fallback={
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-evenly",
                          alignItems: "center",
                          height: "calc(100vh - 4rem)",
                        }}
                      >
                        <div className="lds-ring">
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                      </div>
                    }
                  >
                    <ErrorBoundary>
                      <OrmWidget
                        data={panes[index]?.section[0]?.widgets}
                        dashboard={true}
                      />
                    </ErrorBoundary>
                  </Suspense>
                ) : panes[index]?.template_id === "000-000-101" ? (
                  <Suspense
                    fallback={
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-evenly",
                          alignItems: "center",
                          height: "calc(100vh - 4rem)",
                        }}
                      >
                        <div className="lds-ring">
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                      </div>
                    }
                  >
                    <ErrorBoundary>
                      <Element name={activeSectionKey} key={uuid()}>
                        <Socailchannel dashboardData={panes[index]} />
                      </Element>
                    </ErrorBoundary>
                  </Suspense>
                ) : panes[index]?.template_id === "000-000-002" ? (
                  <>
                    {panes[index]?.sections?.map((e, i) => {
                      return (
                        <ErrorBoundary>
                          <TicketTATSimpleViewSection
                            key={e?.section_id}
                            dashboardData={e}
                            section_id={e?.section_id}
                          />
                        </ErrorBoundary>
                      );
                    })}
                  </>
                ) : panes[index]?.template_id === "000-000-003" ? (
                  <>
                    {panes[index]?.sections?.map((e, i) => {
                      return (
                        <ErrorBoundary>
                          <AgentActivitySectionInsights
                            key={e?.section_id}
                            dashboardData={e}
                            section_id={e?.section_id}
                          />
                        </ErrorBoundary>
                      );
                    })}
                  </>
                ) : (
                  panes[index]?.template_id === "000-000-004" && (
                    <ErrorBoundary>
                      <Element name={activeSectionKey} key={uuid()}>
                        <TicketOverview dashboardData={panes[index]} />
                      </Element>
                    </ErrorBoundary>
                  )
                )}
              </div>
            ) : (
              <div
                className="p-15 pb-0 bg__gray section_insight"
                id="scroll"
                style={{
                  height:
                    ((panes[index]?.quick_filter &&
                      panes[index]?.profiles?.length === 0) ||
                      panes?.[index]?.campaign_date?.from >
                        moment(new Date()).format("YYYY/MM/DD H:mm")) &&
                    "calc(100vh - 16.4rem)",
                }}
              >
                <div className="row full">
                  {profileLoader ||
                  sectionLoader?.index === 0 ||
                  templateSectionFetchLoader ? (
                    <>
                      <div
                        className="loader text-center w-100"
                        style={{ height: "calc(100vh - 15.2rem)" }}
                      >
                        <div className="lds-ring">
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <div
                      className={`col-12 ${
                        isWidgetEdit ? "col-md-9" : "col-md-12"
                      }`}
                      id="SectionContainerMain"
                      name="SectionContainerMain"
                    >
                      {panes?.[index]?.is_ai_dashboard &&
                      !panes?.[index]?.is_ai_access ? (
                        <>
                          <div
                            className="w-100 d-flex align-items-center"
                            style={{ height: "calc(100vh - 182px)" }}
                          >
                            <div className="text-center w-100">
                              <img
                                src={NoAiAcessImage}
                                alt="AI Stars Image"
                                className="mb-15"
                                style={{ height: "200px" }}
                              />
                              <div className="text_heading font-weight600 font-size16">
                                This feature is not enabled for you.
                              </div>
                              <div className="text_regular-gray">
                                To enable this feature contact your customer
                                success representative.
                              </div>
                            </div>
                          </div>
                        </>
                      ) : panes[index]?.quick_filter &&
                        panes[index]?.profiles?.length === 0 ? (
                        <div
                          className="w-100 d-flex align-items-center"
                          style={{ height: "calc(100vh - 18.2rem)" }}
                        >
                          <div className="text-center w-100">
                            <img
                              src={AccountNoData}
                              alt="AccountNoData"
                              className="mb-15"
                            />
                            <div className="text_heading font-weight600 font-size16">
                              {/* {panes[index]?.template_type === "competition" &&
                              competitorBrands?.length === 0
                                ? "No competition brands configured!"
                                : "No quick filters available!"} */}
                              {loginAccountType &&
                              parseInt(loginAccountType) === 13
                                ? `No ${getChannelNameFromHiddenFilter(
                                    panes?.[index]?.hidden_filter,
                                    graphConditionConfig
                                  )} profiles available for assigned Location profiles!`
                                : `No ${getChannelNameFromHiddenFilter(
                                    panes?.[index]?.hidden_filter,
                                    graphConditionConfig
                                  )} profiles available!`}
                            </div>
                            <div className="text_regular-gray">
                              {/* {panes[index]?.template_type === "competition" &&
                              competitorBrands?.length === 0
                                ? "Visit accounts section to map competitors"
                                : "Change brand and/or duration to refresh."} */}
                              {loginAccountType &&
                              parseInt(loginAccountType) === 13
                                ? `Change brand and/or duration to refresh or assign more Location profiles.`
                                : "Change brand and/or duration to refresh."}
                            </div>
                          </div>
                        </div>
                      ) : panes?.[index]?.campaign_date?.from >
                        moment(new Date()).format("YYYY/MM/DD H:mm") ? (
                        <div
                          className="w-100 d-flex align-items-center"
                          style={{ height: "calc(100vh - 18.2rem)" }}
                        >
                          <div className="text-center w-100">
                            <img
                              src={AccountNoData}
                              alt="AccountNoData"
                              className="mb-15"
                            />
                            <div className="text_heading font-weight600 font-size16">
                              Campaign not started!
                            </div>
                          </div>
                        </div>
                      ) : sections ? (
                        <>
                          {sections?.map((el, i) => {
                            return (
                              <div key={el?.section_id}>
                                <Element
                                  name={el?.section_id}
                                  id={el?.section_id}
                                  key={i}
                                >
                                  <SectionInsights
                                    title={el?.section_name}
                                    description={el?.section_description}
                                    widgets={el?.widgets}
                                    section_index={i}
                                    section_id={el?.section_id}
                                    sections={sections}
                                    comprtitorBrandFilter={el?.comp_brand_type}
                                  />
                                </Element>
                              </div>
                            );
                          })}
                        </>
                      ) : graphLoader && !section ? (
                        <div
                          className="loader text-center w-100"
                          style={{ height: "calc(100vh - 15.2rem)" }}
                        >
                          <div className="lds-ring">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                          </div>
                        </div>
                      ) : (
                        <div className="row ml-0">
                          {section &&
                            section[0]?.widgets?.map((el, i) => {
                              return (
                                <Widget
                                  key={el?.widget_id + i}
                                  data={el}
                                  nextWidgetdata={
                                    i + 1 < section?.[0]?.widgets?.length
                                      ? section?.[0]?.widgets?.[i + 1]
                                      : null
                                  }
                                  prevWidgetdata={
                                    section?.[0]?.widgets?.[i - 1]
                                  }
                                  onlyWidgets={true}
                                  widget_index={i}
                                  widget_graph_type={el?.graph_type}
                                  section_id={
                                    section?.section_id
                                      ? section?.section_id
                                      : section?.[0]?.section_id
                                  }
                                  widget_id={el?.widget_id}
                                  section={section}
                                />
                              );
                            })}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        )}
        {aiInsightsStatus?.open && <AIInsightsModal />}
        {(panes && panes?.[index]?.isTicketTrandsView) ||
        (shareTemplateData && shareTemplateData?.isTicketTrandsView) ? (
          <Modal
            title={null}
            visible={
              (panes && panes?.[index]?.isTicketTrandsView) ||
              (shareTemplateData && shareTemplateData?.isTicketTrandsView)
            }
            closable={false}
            className={`trandsPopup ${
              authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
            }`}
            footer={null}
          >
            <AgentActivityTrends
            //setTrandView={setTrandView}
            ></AgentActivityTrends>
          </Modal>
        ) : (
          ""
        )}
        {shareBrands ? (
          <FilterDrawer
            onClose={removeFilterPanel}
            setfilterSearch={setfilterSearch}
            filterSearch={filterSearch}
            filterClearTrigger={filterClearTrigger}
            setfilterClearTrigger={setfilterClearTrigger}
            drawer={true}
            type="share_modal"
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
          />
        ) : (
          ""
        )}
      </>
    );
};

export default React.memo(Dashboard, isEqual);
